export const REMOTE_WORK_PATH = '/api/v2/leave/remote-work-requests';
export const REMOTE_WORK_POLICY = '2027-handbook-v1';

export const remoteWorkWeekdays = [
  {id: 1, label: 'Monday'},
  {id: 2, label: 'Tuesday'},
  {id: 3, label: 'Wednesday'},
  {id: 4, label: 'Thursday'},
  {id: 5, label: 'Friday'},
  {id: 6, label: 'Saturday'},
  {id: 7, label: 'Sunday'},
];

export const remoteWorkStatuses = {
  pending_supervisor: 'Pending supervisor review',
  pending_management: 'Pending management approval',
  pending_ed: 'Pending Executive Director approval',
  approved: 'Approved',
  revision_requested: 'Changes requested',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
  revoked: 'Approval withdrawn',
  superseded: 'Replaced by a revised request',
};

export const remoteWorkActionLabels = {
  approve: 'Approve',
  reject: 'Reject',
  cancel: 'Cancel request',
  revoke: 'Withdraw approval',
  revise: 'Revise request',
  request_revision: 'Request changes',
};

export function permittedRemoteWorkActions(request) {
  return (request?.actions || []).filter((action) =>
    Object.prototype.hasOwnProperty.call(remoteWorkActionLabels, action),
  );
}

export function timezoneOption(timezone) {
  return {id: timezone, label: timezone.replace(/_/g, ' ')};
}

export function remoteWorkForm(request = null) {
  const timezone =
    request?.timezone ||
    Intl.DateTimeFormat().resolvedOptions().timeZone ||
    'America/New_York';
  return {
    fromDate: request?.fromDate || null,
    toDate: request?.toDate || null,
    weekdays: remoteWorkWeekdays.filter((day) =>
      (request?.weekdays || [1, 2, 3, 4, 5]).includes(day.id),
    ),
    startTime: request?.startTime?.slice(0, 5) || '',
    endTime: request?.endTime?.slice(0, 5) || '',
    timezone: timezoneOption(timezone),
    address: {
      line1: request?.address?.line1 || '',
      line2: request?.address?.line2 || '',
      city: request?.address?.city || '',
      state: request?.address?.state || '',
      postalCode: request?.address?.postalCode || '',
      country: request?.address?.country || '',
    },
    scheduleNotes: request?.scheduleNotes || '',
    signature: '',
    acknowledged: false,
  };
}

export function remoteWorkPayload(form, policyVersion) {
  return {
    fromDate: form.fromDate,
    toDate: form.toDate,
    weekdays: form.weekdays.map((day) => day.id).sort((a, b) => a - b),
    startTime: form.startTime,
    endTime: form.endTime,
    timezone: form.timezone.id,
    address: Object.fromEntries(
      Object.entries(form.address).map(([key, value]) => [key, value.trim()]),
    ),
    scheduleNotes: form.scheduleNotes.trim(),
    signature: form.signature.trim(),
    acknowledged: form.acknowledged === true,
    policyVersion,
  };
}

export function remoteWorkError(error, fallback) {
  const response = error?.response?.data || error?.data;
  return response?.error?.message || fallback;
}

export function remoteWorkSchedule(request) {
  const days = remoteWorkWeekdays
    .filter((day) => request.weekdays?.includes(day.id))
    .map((day) => day.label.slice(0, 3))
    .join(', ');
  return `${days} · ${request.startTime?.slice(0, 5) || ''}–${
    request.endTime?.slice(0, 5) || ''
  } · ${request.timezone || ''}`;
}

export function todayInTimezone(timezone, now = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(now);
    const date = Object.fromEntries(
      parts.map((part) => [part.type, part.value]),
    );
    return `${date.year}-${date.month}-${date.day}`;
  } catch {
    return '';
  }
}
